import App from "./App.svelte";

const app = new App({
  target: document.body,
  props: {
    googleMapsReady: false,
  },
});

// record when google maps api has loaded
window.initMap = function ready() {
  app.$set({ googleMapsReady: true });
};

export default app;
